// extracted by mini-css-extract-plugin
module.exports = {"contentLayout":"contentLayout--aR83S"};